<template>
<div id="mirrorHome" class="mirrorHome" v-if="brandList !== null" :class="{ 'is-modal': isMirrorMenuModal }">
  <MirrorHeader title="HOME" />
  <div class="mirrorHome__mainvisual">
    <video class="mirrorHome__mainvisual__video" webkit-playsinline playsinline autoplay loop muted poster="@/assets/images/home/home-main-poster.jpg">
      <source src="@/assets/video/mainvisual.webm" type="video/webm">
      <source src="@/assets/video/mainvisual.mp4" type="video/mp4">
      <p>Not Movie Support...</p>
    </video>
    <div class="mirrorHome__mainvisual__txt"><img src="@/assets/images/home/home-main-txt.png" alt="My Custom Bag Studio"></div>
  </div>
  <div class="mirrorHome__subvisual">
    <img src="@/assets/images/home/home-howto.png" width="450" height="200" alt="Howto">
  </div>
  <div class="mirrorHome__title">
    <h2 class="mirrorHome__title__main">SELECT BRAND</h2>
    <p class="mirrorHome__title__sub">対象ブランドを選択してください</p>
  </div>
  <div class="mirrorHome__brandlist">
    <div class="mirrorHome__brandlist__wrap">
      <router-link v-for="brand in brandList" :key="brand.id"
        :to="{ name: 'mirror-item-type', params: { brandID: brand.id } }"
        class="mirrorHome__brandlist__wrap__brand">
        <img :src="brand.mainImage" :alt="brand.name" />
      </router-link>
    </div>
  </div>
  <MirrorFooter />
  <div @click="isMirrorMenuModal = true" class="mirrorGlobalMenu">
    <img src="@/assets/images/mirror/commons/commons-menu.svg" alt="Menu">
  </div>
  <MirrorMenuModal
    v-if="isMirrorMenuModal"
    @closeMenu="isMirrorMenuModal = false" />
  <ScreenSaverModal
    v-if="isScreenSaver"
    @closeScreenSaver="isScreenSaver = false" />
</div>
</template>

<script>
import MirrorHeader from '@/components/mirror/MirrorHeader'
import MirrorFooter from '@/components/mirror/MirrorFooter'
import MirrorMenuModal from '@/components/mirror/MirrorMenuModal'
import ScreenSaverModal from '@/components/mirror/ScreenSaverModal'
import ScreenSaver from '@/assets/class/ScreenSaver'
import customMgr from '@/modules/CustomManager'

export default {
  mixins: [ScreenSaver],
  components: {
    MirrorHeader,
    MirrorFooter,
    MirrorMenuModal,
    ScreenSaverModal
  },
  beforeRouteEnter (to, from, next) {
    customMgr.getAllBrands('mirror').then((brandList) => {
      next(vm => vm.setBrandList(brandList))
    })
  },
  data () {
    return {
      brandList: null,
      isMirrorMenuModal: false
    }
  },
  metaInfo: {
    meta: [
      { name: 'viewport', content: 'width=1080,user-scalable=no' }
    ]
  },
  methods: {
    setBrandList (brandList) {
      this.brandList = brandList
    }
  }
}
</script>

<style lang="scss" scoped>
.mirrorHome {
  min-height: 100%;
  background-color: #FFE5E8;
  &__mainvisual {
    width: 100%;
    height: 600px;
    position: relative;
    background: #D9747F;

    &__txt {
      position: absolute;
      right: 60px;
      top: 180px;
    }
  }
  &__subvisual {
      background: #FFE5E8;
      padding: 30px 0;
      text-align: center;
      img {
        position: relative;
        left: 10px;
        width: 400px;
      }
  }
  &.is-modal {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  &__title {
    background-color: $base-white;
    text-align: center;
    padding: 70px 0 40px;
    &__main {
      font-size: 50px;
      font-weight: bold;
    }
    &__sub {
      font-size: 25px;
      margin-top: 15px;
    }
  }
  &__brandlist {
    &__wrap {
      padding: 50px 100px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap;
      &__brand {
        width: calc((100% - 60px) / 3);
        height: 230px;
        background-color: $base-white;
        margin: 0 0 30px 0;
        padding: 40px;
        &:nth-of-type(3n + 2) {
          margin: 0 30px 30px;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
  }
  .mirrorGlobalMenu {
    @include mirrorMenuBtn;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/mirror/MirrorHome.vue